import { debounce, formatMoney, startViewTransition } from '@theme/utilities';


// class remove on touchmove

const element = document.querySelector('html');

function removeClassOnScrollTouchMoveOrMouseMove() {
  element.classList.remove('hide-items');
}

document.addEventListener('touchmove', removeClassOnScrollTouchMoveOrMouseMove, { passive: true });
document.addEventListener('scroll', removeClassOnScrollTouchMoveOrMouseMove);
document.addEventListener('mousemove', removeClassOnScrollTouchMoveOrMouseMove);

// mobile menu toggle JS start

document.addEventListener("DOMContentLoaded", function () {
  const submenuLinks = document.querySelectorAll('.has-submenu');

  submenuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const parentItem = this.closest('.menu__item');
      document.querySelectorAll('.menu__item.active_submenu').forEach(item => {
        if (item !== parentItem) {
          item.classList.remove('active_submenu');
        }
      });
      parentItem.classList.toggle('active_submenu');
    });
  });
  const grandToggleLinks = document.querySelectorAll('.sub-toggle');

  grandToggleLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const parentLink = this.closest('.menu-link');
      const siblings = parentLink.parentElement.querySelectorAll('.menu-link.active_grand');
      siblings.forEach(sib => {
        if (sib !== parentLink) {
          sib.classList.remove('active_grand');
        }
      });
      parentLink.classList.toggle('active_grand');
    });
  });
});

// mobile menu toggle JS End

// Mobile Menu Drawer Toggle JS Start

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function(event){
    const menuIcon = document.querySelector('.mobile_menu_bar');

    if (event.target.closest('.mobile_menu_bar')) {
      document.querySelector('nav-drawer').classList.add('show_mobile_menu'); 
      document.querySelector('html').setAttribute('scroll-lock', '');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const closeIcon = document.querySelector('.mobile_menu_drawer .drawer_close');

  closeIcon.addEventListener('click',function(){
   document.querySelector('nav-drawer').classList.remove('show_mobile_menu'); 
  document.querySelector('html').removeAttribute('scroll-lock'); 
  });
});

// Mobile Menu Drawer Toggle JS End

// newsletter shaker js start

document.addEventListener("DOMContentLoaded", function () {
  var shakeNewsletter = document.querySelector('.Wrap_newsletter .email-signup__button');
  var emailInput = document.querySelector('.Wrap_newsletter .email-signup__input');
  var shakeElement = document.querySelector('.Wrap_newsletter .email-signup__form');
  
  if(shakeNewsletter && emailInput) {
    shakeNewsletter.addEventListener('click', function() {
      var checkInput = emailInput.value;
      
      if(checkInput == '') {
        shakeElement.classList.add('shake');
        
        setTimeout(function() {
          shakeElement.classList.remove('shake');
        }, 500);
      }
    });
  }
});

// newsletter shaker js End

// Tabs js start

document.addEventListener('DOMContentLoaded', () => {
  const tabGroups = document.querySelectorAll('.tabs_block');

  tabGroups.forEach(group => {
    const headings = group.querySelectorAll('.tabs_heading[data-heading]');
    const panes = group.querySelectorAll('.tabs_content[data-content]');

    headings.forEach(head => {
      head.addEventListener('click', () => {
        headings.forEach(h => h.classList.remove('active'));
        panes.forEach(p => p.classList.remove('active'));

        head.classList.add('active');
        const id = head.dataset.heading;

        const targetPane = group.querySelector(`.tabs_content[data-content="${id}"]`);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });
});

// Tabs js End

// size popup trigger

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product-information__media slideshow-component')) {
    var getHeight = document.querySelector('.product-information__media slideshow-component').offsetHeight;
    document.querySelector('.product-information').style.setProperty('--slideshow-height', getHeight + 'px');
  }
  var checkSize = document.querySelector('.size_text');
  if(checkSize){
    checkSize.addEventListener('click',function(){
      document.querySelector('.popup-link .size-guide').click();
    });
  }

  // Price Range slider Js

  
  if (document.querySelector('facets-form-component')) {
    function removeDesktopOnMobile() {
    if (window.innerWidth <= 767) {
      const desktop = document.querySelector('#main_desktop');
      if (desktop) desktop.remove();
    }
  }
    window.updatePrice = function () {
      const currencySymbol =document.querySelector('body').dataset.currency;
      const minRange = document.querySelector('.field__input-price.min');
      const maxRange = document.querySelector('.field__input-price.max');
      const minVal = document.querySelector('.minimimum-filter__price');
      const maxVal = document.querySelector('.maximum-filter__price');
      
      const minInputHidden = document.querySelector('.min_price_original');
      const maxInputHidden = document.querySelector('.max_price_original');
      
      const minGap = 10;
      
      function debounce(func, delay = 300) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func(...args), delay);
        };
      }
      
      function updateSlider(event) {
        let minValue = parseInt(minRange.value);
        let maxValue = parseInt(maxRange.value);
      
        if (maxValue - minValue < minGap) {
          if (event.target === minRange) {
            minValue = maxValue - minGap;
            minRange.value = minValue;
          } else {
            maxValue = minValue + minGap;
            maxRange.value = maxValue;
          }
        }
      
        minVal.textContent = `${currencySymbol}${minRange.value}`;
        maxVal.textContent = `${currencySymbol}${maxRange.value}`;
      
        if (minInputHidden) minInputHidden.value = minRange.value;
        if (maxInputHidden) maxInputHidden.value = maxRange.value;
      }
      
      function triggerPriceUpdate() {
        const minValue = minRange.value;
        const maxValue = maxRange.value;
      
        if (!minValue || !maxValue || parseInt(maxValue) <= parseInt(minValue)) return;
      
        const priceFacet = document.querySelector('price-facet-component');
        if (priceFacet) {
          priceFacet.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      const debouncedTrigger = debounce(triggerPriceUpdate, 400);

      minRange.addEventListener('input', updateSlider);
      maxRange.addEventListener('input', updateSlider);
      
      minRange.addEventListener('change', debouncedTrigger);
      maxRange.addEventListener('change', debouncedTrigger);

      updateSlider({ target: maxRange });
      
    }
    
    window.updatePrice();
    setInterval(function(){
      removeDesktopOnMobile();
    },1000);
  }

  // Price range slider end

});
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video");

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const sources = video.querySelectorAll("source[data-src]");

        sources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });

        video.load();

        // Try autoplay if muted
        if (video.muted) {
          video.play().catch(() => {
            // Do nothing, no controls
          });
        }

        obs.unobserve(video);
      }
    });
  });

  videos.forEach(video => observer.observe(video));
});


// chat icon js start

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const interval = setInterval(() => {
      const element = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (element && element.shadowRoot) {

        const root = element.shadowRoot;

        const qs = (sel) => root.querySelector(sel);

        if (root) {
          let style = document.createElement('style');
          style.textContent = `
            /* Ensure these styles are applied inside the shadow DOM */
            :host {
              display: block;
            }
            
            button.chat-toggle {
              width: 40px !important;
              height: 40px !important;
              border: 3px solid #fff;
            }

            button.chat-toggle svg {
              width: 30px !important;
              height: 30px !important;
            }

            .chat-notification {
              width: 18px !important;
              height: 18px !important;
              line-height: 18px !important;
            }
             @media (max-width: 450px) {
              button.chat-toggle {
                width: 25px !important;
                height: 25px !important;
                border: 3px solid #fff;
              }
              button.chat-toggle svg {
                width: 20px !important;
                height: 20px !important;
              }
            }
          `;
          root.appendChild(style);

          clearInterval(interval);
        }
      }
    }, 200);
  }, 1000); 
});

(function() {
    if (document.body.classList.contains('itg_store-locator')) {
        function processSocialLinks() {
            var allSocialLinks = document.querySelectorAll('.social-link');

            allSocialLinks.forEach(function(links) {
                if (!links.classList.contains('social-loaded')) {
                    var getHref = links.querySelector('a') ? links.querySelector('a').getAttribute('href') : '';
                    
                    if (getHref) {
                        var socialLinks = getHref.split(','); 

                        var newDiv = document.createElement('div');
                        newDiv.classList.add('social-links-container'); 

                        socialLinks.forEach(function(link) {
                            var anchorTag = document.createElement('a');
                            anchorTag.setAttribute('href', link.trim());
                            anchorTag.setAttribute('target', '_blank');
                            var linkText = link.trim();

                            if (linkText.includes('facebook')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/facebook_4628653.png?v=1758821127">';
                            } 
                            if (linkText.includes('twitter') || linkText.includes('https://x.com')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/twitter_4628695.png?v=1758821500">';
                            }
                            if (linkText.includes('instagram')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/instagram_4628656.png?v=1758821302">';
                            } 
                            if (linkText.includes('linkedin')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/linkedin_4628658.png?v=1758821189">';
                            } 
                            if (linkText.includes('tiktok')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/music_14459372.png?v=1759167606">';
                            } 
                            if (linkText.includes('https://wa.me')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/chat-bubble_5441403.png?v=1759167930">';
                            }
                            if (linkText.includes('youtube')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/youtube_4628711.png?v=1758821436">';
                            }
                            if (linkText.includes('pinterest')) {
                                anchorTag.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/svgviewer-png-output_8.png?v=1758815253">`;
                            }
                            newDiv.appendChild(anchorTag);
                        });

                        links.appendChild(newDiv);
                        links.classList.add('social-loaded');
                    }
                }
            });
        }

        // Create a MutationObserver to monitor changes in the document
        var observer = new MutationObserver(function(mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    if (mutation.target.classList.contains('social-link') || mutation.type === 'childList') {
                        // Re-run processSocialLinks if the social link is added or changed
                        processSocialLinks();
                    }
                }
            }
        });

        // Start observing for changes in the body (or a more specific container if needed)
        observer.observe(document.body, {
            childList: true,      // Watch for added or removed elements
            subtree: true,        // Watch all descendant nodes
            attributes: true,     // Watch for attribute changes
            attributeFilter: ['href'] // Specifically watch the `href` attributes of the links
        });
    }
    
    var sizeGuide = document.querySelector('.size-guide-tab');
    if (sizeGuide) {
        sizeGuide.addEventListener('click', function() {
            var sizeGuideElements = document.querySelectorAll('[data-heading="size-guide"]');
            
            if (sizeGuideElements.length > 0) {
                sizeGuideElements.forEach(function(sizeGuideElement) {
                    console.log(sizeGuideElement);
                    sizeGuideElement.click();
                    sizeGuideElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            } else {
                console.error('Size guide elements not found');
            }
        });
    }
})();




